export const PRESET = 'preparation_phase';

export const shellSx = {
  bgcolor: '#fff',
  borderRadius: 1.5,
  border: '1px solid #e2e8f0',
  overflow: 'hidden',
  boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
};

export const prepCellPad = '6px 8px';

export const prepThSx = {
  fontSize: '0.68rem',
  fontWeight: 700,
  color: '#64748b',
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  padding: prepCellPad,
  borderBottom: '1px solid #e2e8f0',
  bgcolor: '#fafbfc',
  whiteSpace: 'nowrap',
  lineHeight: 1.35,
};

export const prepTdSx = {
  padding: prepCellPad,
  fontSize: '0.76rem',
  borderBottom: '1px solid #f1f5f9',
  verticalAlign: 'top',
};

export const prepTdNumSx = {
  ...prepTdSx,
  padding: '6px 6px',
};

export const PREP_COL = {
  ticker: 156,
  score: 72,
  signal: 220,
  sector: 120,
  close: 88,
  dist: 88,
  accum: 72,
  upDown: 72,
  trigger: 108,
  reasons: 258,
};

export const PREP_TABLE_MIN_WIDTH = Object.values(PREP_COL).reduce((sum, w) => sum + w, 0);

export const compactFieldSx = {
  minWidth: 0,
  '& .MuiInputBase-root': { fontSize: 13, height: 36 },
  '& .MuiOutlinedInput-input': { py: '9.5px' },
  '& .MuiSelect-select': { py: '9.5px' },
  '& .MuiInputLabel-root': {
    transform: 'translate(14px, -8px) scale(0.75)',
    transformOrigin: 'top left',
    px: 0.5,
    bgcolor: '#fafbfd',
  },
  '& .MuiInputLabel-shrink': { transform: 'translate(14px, -8px) scale(0.75)' },
  '& .MuiFormHelperText-root': { display: 'none' },
};

export const TIER_META = {
  veryStrong: { color: '#16a34a', bg: '#dcfce7' },
  strong: { color: '#0ea5e9', bg: '#e0f2fe' },
  fair: { color: '#7c3aed', bg: '#ede9fe' },
  average: { color: '#b45309', bg: '#fef3c7' },
  weak: { color: '#94a3b8', bg: '#f1f5f9' },
};
